/**
 * This snippet is mainly intended for use with `src/App.tsx`.
 * 
 * This is a custom hook which will store metadata of local server after handshakes
 */

import { useState } from "react"

export const useMetadata = () => {
    const [isGitSupported, setIsGitSupported] = useState(false);

    return {
        metadata: {
            isGitSupported
        },
        setIsGitSupported
    }
}